import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const PHIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="PH" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#BF2714"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#3D58DB"
          fillRule="evenodd"
          d="M0-1v7h16v-7H0Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12l9-6-9-6Z"
        clipRule="evenodd"
      />
      <Mask
        id="c"
        width={9}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12l9-6-9-6Z"
          clipRule="evenodd"
        />
      </Mask>
      <G fill="#FECA00" mask="url(#c)">
        <Path
          fillRule="evenodd"
          d="m6.803 5.46.638.246.38-.447.01.598.586.19-.618.21.041.55-.407-.421-.64.122.378-.485-.368-.563ZM.803 8.46l.586.26.431-.46-.041.61.638.178-.67.223.093.536-.466-.383-.58.084.325-.471-.316-.577ZM.803 2.46l.648.24.37-.44.02.59.576.198-.607.203.03.555-.404-.403-.643.105.389-.492-.38-.556ZM4.06 7.266a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
          clipRule="evenodd"
        />
        <Path d="M4.134 6.888a.113.113 0 0 1 .092.097l.05.842a.191.191 0 1 1-.378-.007l.107-.84a.112.112 0 0 1 .129-.092Zm-.826-.278a.112.112 0 0 1 .153.16l-.55.67a.191.191 0 0 1-.289.016.191.191 0 0 1 .027-.288l.659-.558Zm.59.356c.034.009.05.04.043.07l-.095.347a.079.079 0 0 1-.091.056l-.009-.001a.065.065 0 0 1-.04-.082l.115-.346a.068.068 0 0 1 .078-.044Zm.422.038c.036-.006.07.013.079.046l.104.35c.01.034-.01.07-.044.08l-.008.001a.08.08 0 0 1-.09-.059l-.083-.351a.056.056 0 0 1 .042-.067Zm.466-.41a.112.112 0 0 1 .133.002l.648.564a.19.19 0 1 1-.271.262l-.537-.673a.112.112 0 0 1 .027-.156Zm-1.272.256c.03.021.038.058.022.088l-.173.32a.065.065 0 0 1-.088.026c-.002 0-.004-.002-.006-.004a.08.08 0 0 1-.021-.106l.188-.306a.057.057 0 0 1 .078-.018Zm1.16-.036c.03-.016.064-.007.08.02l.177.312a.08.08 0 0 1-.03.11.065.065 0 0 1-.088-.03L4.651 6.9a.067.067 0 0 1 .024-.086Zm-1.517-.312a.067.067 0 0 1 .085.022c.017.03.008.064-.018.08l-.313.178a.08.08 0 0 1-.105-.025l-.004-.007a.064.064 0 0 1 .029-.086l.326-.162Zm1.93.018.32.173a.065.065 0 0 1 .027.088l-.005.007a.079.079 0 0 1-.105.021l-.307-.189A.056.056 0 0 1 5 6.543a.067.067 0 0 1 .088-.023ZM2.986 6.13c.03-.007.06.012.067.041a.067.067 0 0 1-.046.079l-.35.103a.064.064 0 0 1-.08-.043l-.002-.007a.08.08 0 0 1 .06-.09l.351-.083Zm-.746-.36.837.086a.112.112 0 0 1-.005.222l-.84.068a.19.19 0 1 1 .008-.376Zm3.292.442a.08.08 0 0 1 .057.092l-.002.007a.065.065 0 0 1-.082.04l-.345-.114a.068.068 0 0 1-.045-.078.057.057 0 0 1 .07-.042l.347.095Zm.437-.445a.19.19 0 1 1-.007.377L5.13 6.05a.112.112 0 0 1 .004-.22l.835-.065ZM2.7 5.556l.345.116c.032.01.052.044.045.077-.01.033-.04.05-.07.042l-.347-.094a.08.08 0 0 1-.057-.092l.002-.008a.065.065 0 0 1 .082-.041Zm2.848-.002c.034-.01.07.01.08.044l.002.008a.08.08 0 0 1-.06.09l-.35.083a.056.056 0 0 1-.068-.042.068.068 0 0 1 .047-.08l.349-.103Zm-2.666-.456.306.19c.026.015.034.05.018.076-.021.03-.058.04-.088.023l-.32-.173a.065.065 0 0 1-.027-.088l.005-.007a.08.08 0 0 1 .106-.02Zm-.325-.625a.191.191 0 0 1 .288.026l.6.66a.112.112 0 0 1-.16.153l-.71-.551a.19.19 0 0 1-.018-.288Zm2.738.652a.078.078 0 0 1 .108.031.065.065 0 0 1-.028.087l-.327.163a.067.067 0 0 1-.085-.024c-.017-.03-.008-.064.019-.079l.313-.178Zm.008-.604a.191.191 0 0 1 .268-.035c.007.005.013.012.02.019a.19.19 0 0 1-.026.287l-.667.505a.112.112 0 0 1-.154-.16l.559-.616Zm-1.997.131a.064.064 0 0 1 .086.029l.162.326a.067.067 0 0 1-.023.086c-.03.017-.063.007-.079-.02l-.179-.312a.078.078 0 0 1 .025-.104l.008-.005Zm1.624-.03.007.005a.08.08 0 0 1 .021.106l-.19.306a.056.056 0 0 1-.076.019.067.067 0 0 1-.023-.088l.173-.321a.065.065 0 0 1 .088-.026Zm-.825-.718a.191.191 0 0 1 .184.223l-.088.8a.112.112 0 0 1-.222-.004l-.067-.803a.19.19 0 0 1 .193-.216Zm.354.566a.065.065 0 0 1 .041.082l-.116.345a.068.068 0 0 1-.078.044.057.057 0 0 1-.042-.069l.095-.348a.08.08 0 0 1 .092-.056c.003 0 .005 0 .008.002Zm-.704-.045a.08.08 0 0 1 .089.06l.083.35a.056.056 0 0 1-.042.068.067.067 0 0 1-.078-.045l-.104-.35a.064.064 0 0 1 .043-.08l.01-.003Z" />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
